import type {Analysis} from '../../types'
import {clearLocalStorage} from '../../util/storage'

const initialState: Analysis = {
  logs: [],
  params: {},
  resTime: 0,
  totalSize: 0,
  error: {},
  pageNo: 1,
  pageSize: 100,
  pageRange: 5,
  loader: false,
  columns: [],
}

// const constructStringWithObject = (obj) => {
//   var s = ''
//   for (let key in obj) {
//     s += `${(obj[key] === null || typeof obj[key] !== 'object')
//       ? `${key}: ${obj[key]}. ` : `${key}:: ${constructStringWithObject(obj[key])}| `}`
//   }
//   return s
// }

// const rowData = (row) => {
//   for (let key in row) {
//     if (row[key] !== null && row[key].indexOf('{') > -1) {
//       row[key] = constructStringWithObject(JSON.parse(row[key]))
//     }
//   }
//   return row
// }

export default (state: Analysis = initialState, action): Analysis => {
  const {type, data, payload} = action

  switch (type) {
    case 'RESET_FORM':
      return {
        ...state,
        params: {...initialState.params},
      }
    case 'GET_LOGS':
      return {
        ...state,
        loader: true,
      }
    case 'GET_LOGS_SUCCESS':
      // if (data.params.includeOnlySuccess || action.payload.totalCount > 2000) {
      //
      //   // var csvrecord = keys(action.payload.entries[0]).join(',') + '\n'
      //   // action.payload.entries.forEach(function (jsonrecord) {
      //   //   csvrecord += Object.values(rowData(jsonrecord)).join(',') + '\n'
      //   // })
      //   // fileDownloader(csvrecord, 'event_logs.csv', 'application/csv')
      // }
      return {
        ...state,
        loader: false,
        params: data.params,
        columns: data.columns,
        logs: payload.entries,
        totalSize: payload.totalCount,
        error: {},
      }
    case 'GET_LOGS_FAILURE':
      return {
        ...state,
        loader: false,
        error: payload.data || {message: 'Service is unavailable, please try again later.'},
        logs: [],
        totalSize: 0,
        pageNo: 1,
      }
    case 'PAGE_CHANGE':
      return {
        ...state,
        pageNo: data,
      }
    case 'PAGE_SIZE_CHANGE':
      return {
        ...state,
        pageSize: data,
      }
    case 'LOG_OUT':
      clearLocalStorage()
      return {
        ...initialState,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/analysis/reducer.js